import { t } from "ttag";

import { Button, Dialog, VideoCameraIcon } from "@/shared/ui";

export const RedirectToSync = ({
  show,
  onClose,
  onConfirm,
}: {
  show: boolean;
  onClose: () => void;
  onConfirm: () => void;
}) => {
  return (
    <Dialog.Root open={show} onOpenChange={onClose}>
      <Dialog.Content>
        <Dialog.Header icon={VideoCameraIcon}>
          <Dialog.Title>{t`Redirecting to video consultation`}</Dialog.Title>
          <Dialog.Description>
            {t`Based on your form responses, we're guiding you to schedule a video consultation. Get ready to connect with your provider and discuss your needs!`}
          </Dialog.Description>
        </Dialog.Header>

        <Dialog.Footer>
          <Button
            size="lg"
            onClick={() => {
              onConfirm();
              onClose();
            }}
          >
            {t`Continue`}
          </Button>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog.Root>
  );
};
